import React from "react";
import "antd/dist/antd.css";
import { Form, Row, Col, Input, Select, Icon } from "antd";
import { debounce } from "lodash";
class CustomerSearchForm extends React.Component {
  state = {
    countryList: [],
    revisionList: [],
    status: [
      { name: "All Status", value: "" },
      { name: "Active", value: "true" },
      { name: "Disable", value: "false" },
    ],
    sortBy: [{ name: "Default", value: "" }],
    acountAging: [
      { name: "All Aging", value: "" },
      { name: "<= 1Y", value: "1" },
      { name: "<= 2Y", value: "2" },
      { name: "+2Y", value: "3" },
    ],
  };

  async componentDidMount() {
    await this.setFieldsValue();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.countryList !== nextProps.countryList) {
      const propsCountryList = JSON.parse(
        JSON.stringify(nextProps.countryList || []),
      );
      propsCountryList.shift();
      let country = [{ region_code: "", name: "All Country" }];
      propsCountryList.map((v) => country.push(v));
      this.setState({ countryList: country });
    }

    if (this.props.revisionList !== nextProps.revisionList) {
      let revision = [{ id: "", name: "All Revision" }];
      nextProps.revisionList.map((v) => revision.push(v));
      this.setState({ revisionList: revision });
    }
  }

  setFieldsValue = () => {
    this.props.form.setFieldsValue({
      search: "",
      country: "",
      revision: "",
      status: "",
      sortBy: "",
      channel: "",
      owner: "",
      aging: "",
    });
  };

  getFields() {
    const { adminList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const children = [
      <Col key={0} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item>
          {getFieldDecorator("search")(
            <Input
              type="text"
              onChange={this.handleChangeSearch}
              prefix={
                <Icon type="search" style={{ color: "rgba(0,0,0,.25)" }} />
              }
              placeholder="Search Customer"
            />,
          )}
        </Form.Item>
      </Col>,
      <Col key={1} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Country">
          {getFieldDecorator(
            "country",
            {},
          )(
            <Select
              showSearch
              placeholder="Country"
              onChange={(e) => this.handleChangeFilter("country", e)}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "130px" }}
            >
              {(this.state.countryList || []).map((item, i) => (
                <Select.Option key={i} value={item.region_code}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={2} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Revision">
          {getFieldDecorator(
            "revision",
            {},
          )(
            <Select
              placeholder="Revision"
              style={{ width: "130px" }}
              onChange={(e) => this.handleChangeFilter("revision", e)}
            >
              {(this.state.revisionList || []).map((item, i) => (
                <Select.Option key={i} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={3} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Status">
          {getFieldDecorator(
            "status",
            {},
          )(
            <Select
              placeholder="Status"
              style={{ width: "130px" }}
              onChange={(e) => this.handleChangeFilter("status", e)}
            >
              {(this.state.status || []).map((item, i) => (
                <Select.Option key={i} value={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={4} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Sort By">
          {getFieldDecorator(
            "sortBy",
            {},
          )(
            <Select
              placeholder="Sort By"
              onChange={(e) => this.handleChangeFilter("sortBy", e)}
              style={{ width: "130px" }}
            >
              <Select.Option key={1} value={""}>
                Default
              </Select.Option>
              <Select.Option key={2} value={"priority"}>
                Priority
              </Select.Option>
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={5} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Channel">
          {getFieldDecorator(
            "channel",
            {},
          )(
            <Select
              defaultValue={"passive"}
              onChange={(e) => this.handleChangeFilter("channel", e)}
              style={{ width: "130px" }}
            >
              <Select.Option value={""}>All Channel</Select.Option>
              <Select.Option value={"active"}>Active</Select.Option>
              <Select.Option value={"passive"}>Passive</Select.Option>
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={6} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Sales Owner">
          {getFieldDecorator(
            "owner",
            {},
          )(
            <Select
              placeholder="Sales Owner"
              onChange={(e) => this.handleChangeFilter("owner", e)}
              style={{ width: "130px" }}
            >
              <Select.Option value="">All Sales</Select.Option>
              {adminList.map((item, idx) => (
                <Select.Option value={item.id} key={idx}>
                  {item.firstname + " " + item.lastname} ({item.email})
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Col>,
      <Col key={7} xs={{ span: 24 }} md={{ span: 6 }}>
        <Form.Item label="Account Aging">
          {getFieldDecorator(
            "aging",
            {},
          )(
            <Select
              placeholder="Account Aging"
              onChange={(e) => this.handleChangeFilter("aging", e)}
              style={{ width: "130px" }}
            >
              {this.state.acountAging.map((item, idx) => (
                <Select.Option key={idx} value={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Col>,
    ];

    return children;
  }

  handleChangeSearch = (event) => {
    event.persist();
    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        const text = String(event.target.value).replace(/\s/g, "");
        this.props.form.setFieldsValue({
          search: text,
        });
        this.handleSubmit();
      }, 600);
    }

    this.debouncedFn();
  };

  handleChangeFilter = (fName, e) => {
    this.props.form.setFieldsValue({
      [fName]: e,
    });
    this.handleSubmit();
  };

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (values.search) {
        values.search = String(values.search).replace(/\s/g, "");
      }
      this.props.onSearch(values);
    });
  };

  render() {
    return (
      <Form layout="inline" className="ant-advanced-search-form">
        <Row className="search-desktop" gutter={24}>
          {this.getFields()}
        </Row>
      </Form>
    );
  }
}

const Search = Form.create({ name: "advanced_search" })(CustomerSearchForm);
export default Search;



// WEBPACK FOOTER //
// ./src/containers/User/search.js